var dynamicrequest = null;

if ($('.js-loadmore a').length !== 0) {
    $('.js-loadmore a').click(function(e) {
        var selector = $(this).data('selector');
        new loadmoreaction(selector);
    });
}

var loadmoreaction = function(selector, loadmorelink) {
    loadmore = $('.' + selector + ' .js-loadmore');
    loadmorelink = loadmore.find('a');
    loadmore.addClass('action-button--loading');
    loadmorelink.text('*').attr('disabled', true);

    ajaxurl = loadmorelink.data('link');
    hashurl = ajaxurl;

    console.log(ajaxurl)

    if (dynamicrequest) {
        dynamicrequest.abort();
    }

    dynamicrequest = $.ajax({
        type: 'GET',
        url: ajaxurl,
        success: function(response) {
            loadmore.remove();
            dynamicrequest = null;

            $items = $(response);
            $('.' + selector).append($items);

            $('.' + selector + ' .js-loadmore a').click(function(e) {
                new loadmoreaction(selector);
            });
        }
    });
}
